export default "__VITE_PUBLIC_ASSET__e8ab9f4e__"